import { useEffect } from "react";

const useAuthGuard = () => {
  useEffect(() => {
    const customerToken = localStorage.getItem("token");

    if (!customerToken) {
      window.location.href = "https://www.tennisshop.ae/";
    }
  }, []);
};

export default useAuthGuard;
